export const METODOS_PAGO = [
    { value: "efectivo", label: "Efectivo" },
	{ value: "tarjeta-debito", label: "Tarjeta Débito" },
	{ value: "tarjeta", label: "Tarjeta Crédito" },
	{ value: "cheque", label: "Cheque" },
	{ value: "transferencia", label: "Transferencia" },
	{ value: "deposito", label: "Deposito" },
	{ value: "otro", label: "Otro" },
];

export const ESTADOS_TRANSACCION = [
    { value: "pendiente", label: "Pendiente" },
	{ value: "pagada", label: "Pagada" },
	{ value: "cancelada", label: "Cancelada" },
	{ value: "procesando", label: "Procesando" },
	{ value: "incobrable", label: "Incobrable" },
];

// El estado vive en el cheque, no en sus documentos. Solo cambia con
// validar / anular (API: cheques/:id/validar, cheques/:id/anular).
export const ESTADOS_CHEQUE = [
	{ value: "procesando", label: "Procesando", badge: "warning" },
	{ value: "válido", label: "Válido", badge: "success" },
	{ value: "rechazado", label: "Rechazado", badge: "danger" },
	{ value: "devuelto", label: "Devuelto", badge: "secondary" },
];

export const ESTADOS_COTIZACIONES = [
    { value: "pendiente", label: "Pendiente" },
	{ value: "facturada", label: "Facturada" },
	{ value: "cancelada", label: "Cancelada" },
];
